import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Scrollbars} from 'react-custom-scrollbars';
import Modal from '../UI/Modal';
import {Icon} from '../UI/Icon';
import {structure} from '../../../store/actions/content';
import {GenerateRecursiveChildsWithParams, getPageUrl} from '../../helpers/Helpers';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import Collapsible from 'react-collapsible';
import {collapsibleSettings} from '../../helpers/Helpers';
import BtnPrimary from "../UI/BtnPrimary";
import BtnSecondary from "../UI/BtnSecondary";
import Input from "../Fields/Input";

class InternalLinkField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            search: false,
            link: {},
            data: {},
            open: {}
        };
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            this.setState({
                link: value
            });
        }
    }

    showModal() {
        this.setState({
            modal: true,
            search: false
        });
    }

    hideModal() {
        const {input} = this.props;
        this.setState({
            link: input.value,
            modal: false,
            search: false
        });
    }

    save() {
        this.props.input.onChange(this.state.link);
        let newState = {
            link: {...this.state.link},
            modal: false,
            search: false
        };
        this.setState(newState);
    }

    search(e) {
        e.preventDefault();

        const {content} = this.props;

        if (e.target.value && e.target.value !== '') {
            this.setState({
                search: e.target.value
            }, () => {
                this.props.structure(content.parentWorkspaceId, true).then(response => {
                    if (response.data) {
                        this.setState({
                            data: {
                                ...this.state.data,
                                [content.parentWorkspaceId]: GenerateRecursiveChildsWithParams(response.data, content.parentWorkspaceId, this.select.bind(this), this.state.link.contentId, this.state.search)
                            },
                            open: {
                                ...this.state.open,
                                [content.parentWorkspaceId]: true
                            }
                        }, () => {
                            let target = document.getElementsByClassName('csod-awave--match');

                            if (target && target[0]) {
                                this.scrollbars.scrollTop(target[0].offsetTop);
                            }
                        });

                    }
                });
            });
        } else {
            this.setState({
                search: false
            }, () => {
                this.props.structure(content.parentWorkspaceId, true).then(response => {
                    if (response.data) {
                        this.setState({
                            data: {
                                ...this.state.data,
                                [content.parentWorkspaceId]: GenerateRecursiveChildsWithParams(response.data, content.parentWorkspaceId, this.select.bind(this), this.state.link.contentId, this.state.search)
                            },
                            open: {
                                ...this.state.open,
                                [content.parentWorkspaceId]: true
                            }
                        }, () => {
                            let target = document.getElementsByClassName('csod-awave--match');

                            if (target && target[0]) {
                                this.scrollbars.scrollTop(target[0].offsetTop);
                            }
                        });
                    }
                });
            });
        }
    }

    edit(e) {
        e.preventDefault();

        const {input, content} = this.props;

        this.setState({
            data: {},
            open: {},
            search: false
        });

        if (content && content.parentWorkspaceId) {
            this.loadStructure(content.parentWorkspaceId);
        }

        this.setState({
            modal: true,
            link: input && input.value ? input.value : {}
        });
    }

    isSaveDisabled() {
        const {link} = this.state;
        const {omitTitle} = this.props;

        if (omitTitle) {
            return !link.contentId || link.contentId === '';
        } else {
            return !link.contentId || link.contentId === '';
        }
    }

    clear(e) {
        e.preventDefault();

        const {link} = this.state;
        const {input} = this.props;

        let l = {
            ...link,
            title: "",
            contentId: 0,
            target: false
        };

        this.setState({
            link: l,
            data: {},
            open: {},
            search: false
        }, function () {

            input.onChange(null);
        });
    }

    toggleOpen(parentWorkspaceId) {
        const open = this.state.open[parentWorkspaceId];

        this.setState({
            open: {
                ...open,
                [parentWorkspaceId]: !open
            }
        });
    }

    select(parentWorkspaceId, id, title) {
        this.setState({
            link: {
                ...this.state.link,
                'contentId': id,
                'page': title
            }
        });

        this.props.structure(parentWorkspaceId, true).then(response => {
            if (response.data) {
                this.setState({
                    data: {
                        ...this.state.data,
                        [parentWorkspaceId]: GenerateRecursiveChildsWithParams(response.data, parentWorkspaceId, this.select.bind(this), this.state.link.contentId, this.state.search)
                    },
                    search: false
                });
            }
        });
    }

    loadStructure(parentWorkspaceId) {
        this.props.structure(parentWorkspaceId, true).then(response => {
            if (response.data) {
                this.setState({
                    data: {
                        ...this.state.data,
                        [parentWorkspaceId]: GenerateRecursiveChildsWithParams(response.data, parentWorkspaceId, this.select.bind(this), this.state.link.contentId, this.state.search)
                    }
                });

                this.toggleOpen(parentWorkspaceId);
            }
        });
    }

    isOpen(parentWorkspaceId) {
        return this.state.open[parentWorkspaceId];
    }

    renderPages(parentWorkspaceId) {
        return this.state.data[parentWorkspaceId] ? this.state.data[parentWorkspaceId] : null;
    }

    getUrlField() {
        const {link} = this.state;
        const {disabled, label} = this.props;
        return (
            <Input
                label={label ? label : "Internal url"}
                type="text"
                id="link_url"
                name="link_url"
                placeholder={"Click here to select page"}
                value={link.contentId ? link.page : ""}
                title={link.contentId ? getPageUrl(link.contentId) : ""}
                readOnly={true}
                onFocus={this.edit.bind(this)}
                disabled={disabled}
            />
        );
    }

    getTitleField() {
        const {link} = this.state;
        const {input, disabled} = this.props;
        return (
            <div
                className={classNamesPrefixed({
                    'form-item': true,
                    'form-text': true
                })}
            >
                <Input
                    label={"Link title"}
                    type="text"
                    id="link_title"
                    name="link_title"
                    placeholder="Type link title here"
                    defaultValue={link.title}
                    value={(input.value && input.value.title) ? input.value.title : ""}
                    disabled={disabled}
                    onChange={(e) => {
                        let l = {
                            ...link,
                            'title': e.target.value
                        }
                        this.setState({
                            link: l
                        });
                        input.onChange(l);
                    }}
                />

            </div>
        )
    }

    getSaveButton() {
        return (
            <div className={classNamesPrefixed({'form-actions': true})}>
                <BtnPrimary
                    small
                    icon={"save"}
                    disabled={this.isSaveDisabled()}
                    onClick={(e) => {
                        e.preventDefault();
                        this.save();
                    }}>Save</BtnPrimary>
            </div>
        );
    }

    getModalForm() {
        const {modal, link} = this.state;
        const {workspace} = this.props;

        return (
            <Modal
                showModal={modal}
                onClose={() => {
                    this.hideModal();
                }}
                title="Add internal link"
                icon="link"
                modalFooter={this.getSaveButton()}>
                <div>
                    <div
                        className={classNamesPrefixed({
                            'form-item': true,
                            'form-text': true
                        })}
                    >
                        <Input
                            type="text"
                            id="search"
                            name="search"
                            placeholder="Search by title"
                            value={this.state.search ? this.state.search : ''}
                            onChange={(e) => {
                                this.search(e);
                            }}
                            icon={"search"}
                        />
                    </div>
                </div>
                <div>
                    <div
                        className={classNamesPrefixed({
                            'form-item': true,
                            'form-text': true
                        })}
                    >
                        <label htmlFor="link_url">Link destination</label>
                        <div
                            className={classNamesPrefixed({
                                'list-selector': true,
                            })}
                        >
                            <Scrollbars
                                ref={(ref) => this.scrollbars = ref}
                                autoHide={true}
                                autoHeight={true}
                                autoHeightMin={0}
                                autoHeightMax={300}
                            >
                                <ul className={classNamesPrefixed({'scrollable-list': true})}>
                                    {workspace.items.map((item) => {
                                        return (
                                            <li
                                                key={item.id}
                                                className={classNamesPrefixed({
                                                    'open': this.isOpen(item.id),
                                                    'closed': !this.isOpen(item.id)
                                                })}
                                            >
                                                <div
                                                    className={classNamesPrefixed({
                                                        'title': true
                                                    })}
                                                >
                                                    {item.title}
                                                    <div
                                                        className={classNamesPrefixed({
                                                            'icon': true
                                                        })}
                                                        onClick={(e) => {
                                                            e.preventDefault();

                                                            this.loadStructure(item.id);
                                                        }}
                                                    >
                                                        {this.isOpen(item.id) ? (
                                                            <Icon name="chevron-up"/>
                                                        ) : (
                                                            <Icon name="chevron-down"/>
                                                        )}
                                                    </div>
                                                </div>
                                                <ul>
                                                    {this.renderPages(item.id)}
                                                </ul>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Scrollbars>
                        </div>
                    </div>
                </div>
                <div>
                    <div
                        className={classNamesPrefixed({
                            'form-item': true,
                            'form-checkbox': true
                        })}
                    >
                        <label htmlFor="link_target">
                            Open link in new tab
                            <input
                                type="checkbox"
                                id="link_target"
                                name="link_target"
                                defaultChecked={link.target}
                                onChange={(e) => {
                                    this.setState({
                                        link: {
                                            ...link,
                                            'target': e.target.checked
                                        }
                                    });
                                }}
                            />
                            <span/>
                        </label>
                    </div>
                </div>
            </Modal>
        )
    }

    getContent() {
        const {link, modal} = this.state;
        const {input, meta: {touched, error}, omitTitle} = this.props;
        return (
            <Fragment>
                {input.value === '' ? (
                    <Fragment>
                        {!omitTitle && this.getTitleField()}
                        {this.getUrlField()}
                    </Fragment>
                ) : (
                    <Fragment>
                        {!omitTitle && this.getTitleField(link, input)}
                        {this.getUrlField()}
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnSecondary small onClick={this.clear.bind(this)}>Clear</BtnSecondary>
                        </div>
                    </Fragment>
                )}
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
                {modal && this.getModalForm()}
            </Fragment>
        )
    }

    render() {
        const {label, expanded, omitCollapsible} = this.props;
        const content = this.getContent();

        if (omitCollapsible) return content;

        return (
            <Collapsible
                {...collapsibleSettings}
                trigger={label ? <label className={classNamesPrefixed({"trigger__label":true})}>{label}</label> : ''}
                open={expanded}
            >
                {content}
            </Collapsible>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        workspace: state.workspace,
        content: state.content
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        structure: (parentWorkspaceId, skipStore) => dispatch(structure(parentWorkspaceId, skipStore))
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(InternalLinkField)


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/InternalLinkField.js